import { useLoggedUserQuery } from "@/api/user/logged"
import { AppAuthProviderContextLoggedUser } from "../context"
import { useEffect } from "react"

export type AppAuthProviderLoggedUserProps = {
    data: AppAuthProviderContextLoggedUser | undefined
    isLoading: boolean
}

const useAppAuthProviderLoggedUser = (token?: string, onError?: () => void): AppAuthProviderLoggedUserProps => {
    const { data, isError, isLoading } = useLoggedUserQuery(token, { refetchInterval: 10 * 60 * 1000, refetchIntervalInBackground: true })
    useEffect(() => {
        if (isError && onError) {
            onError()
        }
    }, [isError, onError])

    return {
        data,
        isLoading,
    }
}
export default useAppAuthProviderLoggedUser
